import axios from "axios";
const BASE_URL = process.env.REACT_APP_DEV_URL;

export const addAgent = async (token,data) => {
  const url = `${BASE_URL}/accounts/agents/`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  };
  try {
    const response = await axios.post(url, data,config);
    console.log('response....',response);
    
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.log("Error during registration:", error);
    }
  }
};

export const getAllAgents = async (token, params = {}) => {
  const url = `${BASE_URL}/accounts/agents/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
    params,
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const deleteAgent = async (token, agentID) => {
  const url = `${BASE_URL}/accounts/agents/${agentID}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const updateAgent = async (token, data, agentID) => {
  const url = `${BASE_URL}/accounts/agents/${agentID}/`;
  // console.log(url,token,data);
  

  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (key === "image" && data[key] instanceof File && data[key] !== null) {
      formData.append(key, data[key], data[key].name);
    } else {
      formData.append(key, data[key]);
    }
  });
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const response = await axios.patch(url, formData, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error(error);
      throw error;
    }
  }
};

export const getAgent = async (token, agentID) => {
  const url = `${BASE_URL}/accounts/agents/${agentID}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

// ----------------------------- Agent Retailer -----------------------------

export const getAllAgentRetailers = async (token, params = {}) => {
  const url = `${BASE_URL}/accounts/register-retailer/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
    params,
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const addAgentRetailer = async (token, data) => {
  const url = `${BASE_URL}/accounts/register-retailer/`;
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(url, data, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.log("Error during registration:", error);
    }
  }
};

export const updateAgentRetailer = async (token, data, agentID) => {
  const url = `${BASE_URL}/accounts/register-retailer/${agentID}/`;

  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    if (key === "image" && data[key] instanceof File && data[key] !== null) {
      formData.append(key, data[key], data[key].name);
    } else {
      formData.append(key, data[key]);
    }
  });
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const response = await axios.patch(url, formData, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error(error);
      throw error;
    }
  }
};

export const deleteAgentRetailer = async (token, retailerID) => {
  const url = `${BASE_URL}/accounts/register-retailer/${retailerID}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getAgentRetailer = async (token, retailerID) => {
  const url = `${BASE_URL}/accounts/register-retailer/${retailerID}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};
